import React from 'react'

import pokemonlogo from '../../image/pokemonlogo.svg';
import { css } from '@emotion/css';


function PokemonLogo(props) {
    return (
        <div className={css`
            display:block;
            width:100%;
        `}>
            <img className={css`
                width:95%;
                max-width : 500px;
                // height:200px;
                display:block;
                margin:auto;
            `}
                src={pokemonlogo} alt="" />
        </div>
    )
}

PokemonLogo.propTypes = {

}

export default PokemonLogo

